module.exports = __webpack_public_path__ + "static/img/qrcodeWx.9eb1b80.png";